import pagination from '@/common/components/pagination'
import auth from '@/common/auth'
import { Api } from '@/common/api'

export default {
    components: { pagination },
    data: () => ({
        mask_data: '##/##/####',
        mask_cpf: '###.###.###-##',
        mask_rg: '##.###.###-#',
        mask_tel: '####-####',
        mask_cel: '#####-####',
        mask_cep: '#####-###',
        mask_ddd: '##',
        mask_cartao: '#### #### #### ####',
        money: {
            decimal: ',',
            thousands: '.',
            precision: 2,
            masked: false,
        },
        user: {}
    }),
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(2).replace('.', ',')
            return 'R$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        defaultPageChanged(filter, index) {
            filter.pageIndex = index;
            return filter;
        },
        defaultOrderBy(filter, field) {
            let type = 0;
            if (filter.orderByType == 0) type = 1;
            filter.orderFields = field;
            filter.orderByType = type;
            filter.isOrderByDynamic = true;
            return filter;
        },

        defaultSuccessResult(msg) {
            this.hideLoading();
            this.$eventHub.$emit('show-notification', {
                type: 'success',
                title: 'Sucesso',
                text: msg
            })
        },
        defaultErrorResult(err, modal) {
            this.hideLoading();
            if (err.data && err.data.errors) {

                var fullMessage = ""

                for (var i = 0; i < err.data.errors.length; i++) {

                    fullMessage += err.data.errors[i] + "<br />";

                    new Api("LogErro").post({
                        descricao: err.data.errors[i],
                        urlPagina: this.$router.currentRoute.path,
                        attributeBehavior: "SalvaLogErro"
                    }).then(result => { })
                }

                this.$eventHub.$emit('show-notification', {
                    type: 'error',
                    title: 'Atenção',
                    text: fullMessage,
                    modal: modal
                })
            }

            else {
                this.$eventHub.$emit('show-notification', {
                    type: 'error',
                    title: 'Atenção',
                    text: err,
                    modal: modal
                })
            }

        },
        showLoading() {
            this.$eventHub.$emit('show-loading', true)
        },
        hideLoading() {
            this.$eventHub.$emit('show-loading', false)
        },
        failLoading() {
            this.$eventHub.$emit('show-loading', false)
        },
        
    },
    mounted() {
        this.user = auth.currentUser();
        this.$eventHub.$on('user-atualizado', () => {
            this.user = auth.currentUser();
        })
    },
}
